import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './AbonnementSite.css';

const TESTIMONIALS = [
  {
    text: "J'avais peur de me lancer, mais j'ai été très surprise ! On m'avait fait un devis à 4000€ ailleurs. Ici, j'ai eu un site magnifique pour beaucoup moins cher.",
    author: "Natacha",
    role: "Gérante - Le Bac Paris",
    location: "Paris",
    avatar: "NL",
    website: "https://le-bac-paris.e-application.fr"
  },
  {
    text: "Enfin une équipe qui comprend les besoins des commerçants. Support réactif, modifications rapides, je recommande à 100%.",
    author: "Joao",
    role: "Propriétaire - AJ Barber",
    location: "Paris 17ème",
    avatar: "JA",
    website: "https://ajbarber.e-application.fr"
  },
  {
    text: "Le meilleur rapport qualité-prix du marché. Mon ancien prestataire me facturait 300€/mois pour moins de services.",
    author: "Alef",
    role: "Directeur - AYANI Coiffure",
    location: "Paris",
    avatar: "AA",
    website: "https://ayani-coiffure.e-application.fr"
  },
  {
    text: "Un service professionnel et une équipe à l'écoute. Mon site est exactement comme je l'imaginais, mes clients adorent !",
    author: "Gérard",
    role: "Gérant - Panozzi",
    location: "Vincennes",
    avatar: "GP",
    website: "https://panozzi.e-application.fr"
  }
];

function Offres() {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [pricingVisible, setPricingVisible] = useState(false);
  const [showCallPopup, setShowCallPopup] = useState(false);
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [projectUrl, setProjectUrl] = useState('');
  const pricingRef = useRef(null);

  // Auto-rotate testimonials
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTestimonial(prev => (prev + 1) % TESTIMONIALS.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // Show call popup after 8 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCallPopup(true);
    }, 8000);
    return () => clearTimeout(timer);
  }, []);

  // Intersection Observer for Pricing section
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setPricingVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (pricingRef.current) {
      observer.observe(pricingRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const scrollToPricing = () => {
    pricingRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const openProject = (url) => {
    setProjectUrl(url);
    setShowProjectModal(true);
  };

  return (
    <div className="lp">
      {/* Navigation */}
      <nav className="lp-nav">
        <div className="lp-nav-container">
          <div className="lp-logo">
            <span>E-Shops PRO</span>
          </div>
          <div className="lp-nav-links">
            <a href="#" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>Accueil</a>
            <a href="#pricing">Nos offres</a>
            <a href="#testimonials">Témoignages</a>
            <a href="#faq">Questions</a>
            <a href="https://e-shop-pro.fr" target="_blank" rel="noopener noreferrer">Qui sommes-nous</a>
          </div>
          <a href="#pricing" className="lp-nav-cta">Voir les offres</a>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="lp-hero">
        <div className="lp-hero-bg">
          <div className="lp-hero-gradient"></div>
          <div className="lp-hero-pattern"></div>
          <div className="lp-hero-glow"></div>

          {/* Animated Shapes */}
          <div className="lp-hero-shapes">
            <div className="lp-hero-shape lp-hero-shape-1"></div>
            <div className="lp-hero-shape lp-hero-shape-2"></div>
            <div className="lp-hero-shape lp-hero-shape-3"></div>
            <div className="lp-hero-shape lp-hero-shape-4"></div>
            <div className="lp-hero-shape lp-hero-shape-5"></div>
          </div>

          {/* Animated Lines */}
          <div className="lp-hero-lines">
            <div className="lp-hero-line lp-hero-line-1"></div>
            <div className="lp-hero-line lp-hero-line-2"></div>
            <div className="lp-hero-line lp-hero-line-3"></div>
          </div>

          {/* Floating Particles */}
          <div className="lp-hero-particles">
            <div className="lp-hero-particle lp-hero-particle-1"></div>
            <div className="lp-hero-particle lp-hero-particle-2"></div>
            <div className="lp-hero-particle lp-hero-particle-3"></div>
            <div className="lp-hero-particle lp-hero-particle-4"></div>
          </div>
        </div>

        <div className="lp-hero-container">
          <div className="lp-hero-content">
            <div className="lp-hero-badge">
              <span className="lp-badge-dot"></span>
              Nos offres
            </div>

            <h1 className="lp-hero-title">
              La solution
              <span className="lp-hero-title-highlight"> digitale</span>
              <br />adaptée à vos besoins
            </h1>

            <p className="lp-hero-subtitle">
              <span className="lp-hide-mobile">Site web, PWA ou Application mobile native.<br /></span>
              Choisissez la formule qui correspond à votre activité, <strong>tout est inclus</strong>.
            </p>

            <div className="lp-hero-cta">
              <button onClick={scrollToPricing} className="lp-btn lp-btn-primary lp-btn-lg">
                <span>Voir les offres</span>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </button>
              <a href="tel:+33743678501" className="lp-btn lp-btn-ghost">
                Nous appeler
              </a>
            </div>

            <div className="lp-hero-trust">
              <div className="lp-hero-avatars">
                <div className="lp-avatar">A</div>
                <div className="lp-avatar">M</div>
                <div className="lp-avatar">S</div>
                <div className="lp-avatar">+</div>
              </div>
              <div className="lp-hero-trust-text">
                <strong>98% de clients satisfaits</strong> nous recommandent à leur entourage
              </div>
            </div>
          </div>

          <div className="lp-hero-visual">
            <div className="lp-mockup">
              <div className="lp-mockup-browser">
                <div className="lp-mockup-toolbar">
                  <div className="lp-mockup-dots">
                    <span></span><span></span><span></span>
                  </div>
                  <div className="lp-mockup-url">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    </svg>
                    <span>votre-entreprise.fr</span>
                  </div>
                </div>
                <div className="lp-mockup-screen">
                  <div className="lp-mockup-nav"></div>
                  <div className="lp-mockup-hero-img"></div>
                  <div className="lp-mockup-text"></div>
                  <div className="lp-mockup-cards">
                    <div className="lp-mockup-card"></div>
                    <div className="lp-mockup-card"></div>
                    <div className="lp-mockup-card"></div>
                  </div>
                </div>
              </div>

              <div className="lp-mockup-phone">
                <div className="lp-phone-notch"></div>
                <div className="lp-phone-screen">
                  <div className="lp-phone-header"></div>
                  <div className="lp-phone-img"></div>
                  <div className="lp-phone-content">
                    <div className="lp-phone-line"></div>
                    <div className="lp-phone-line short"></div>
                  </div>
                </div>
              </div>

              <div className="lp-floating lp-floating-1">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
                <span>Tout inclus</span>
              </div>

              <div className="lp-floating lp-floating-2">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
                  <line x1="12" y1="18" x2="12.01" y2="18"/>
                </svg>
                <span>Mobile First</span>
              </div>

              <div className="lp-floating lp-floating-3">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
                <span>Support 7j/7</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section with 3 offers */}
      <section className={`lp-pricing ${pricingVisible ? 'lp-pricing-visible' : ''}`} id="pricing" ref={pricingRef}>
        <div className="lp-pricing-bg">
          <div className="lp-pricing-gradient"></div>
          <div className="lp-pricing-grid-pattern"></div>
          <div className="lp-pricing-orb lp-pricing-orb-1"></div>
          <div className="lp-pricing-orb lp-pricing-orb-2"></div>
        </div>

        <div className="lp-pricing-container">
          <div className="lp-pricing-header">
            <span className="lp-section-tag">Nos formules</span>
            <h2>Choisissez votre <span>offre</span></h2>
            <p>Des forfaits tout compris, sans frais cachés</p>
          </div>

          <div className="lp-offers-grid">
            {/* Offre Site Web */}
            <div className="lp-offer-card">
              <div className="lp-offer-badge">Découverte</div>
              <h3>Site Web</h3>
              <p className="lp-offer-desc">Votre vitrine professionnelle en ligne</p>
              <div className="lp-offer-price">
                <span className="lp-offer-amount">89</span>
                <span className="lp-offer-currency">€</span>
                <span className="lp-offer-period">/mois</span>
              </div>
              <ul className="lp-offer-features">
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  Site web professionnel sur mesure
                </li>
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  Design responsive mobile
                </li>
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  Hébergement & SSL inclus
                </li>
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  Maintenance & mises à jour
                </li>
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  Support français 7j/7
                </li>
                <li className="not-included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                  Application mobile
                </li>
                <li className="not-included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                  Notifications push
                </li>
              </ul>
              <div className="lp-offer-actions">
                <Link to="/abonnement-site#pricing" className="lp-offer-btn-primary">
                  Commander
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                </Link>
                <Link to="/abonnement-site#hero" className="lp-offer-btn-secondary">En savoir plus</Link>
              </div>
            </div>

            {/* Offre PWA - Recommandé */}
            <div className="lp-offer-card lp-offer-card-popular">
              <div className="lp-offer-popular-tag">
                <svg viewBox="0 0 24 24" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                Recommandé
              </div>
              <div className="lp-offer-badge lp-offer-badge-purple">Intermédiaire</div>
              <h3>Site + PWA</h3>
              <p className="lp-offer-desc">Site installable sur mobile</p>
              <div className="lp-offer-price">
                <span className="lp-offer-amount">189</span>
                <span className="lp-offer-currency">€</span>
                <span className="lp-offer-period">/mois</span>
              </div>
              <ul className="lp-offer-features">
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  Tout le pack Site Web +
                </li>
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  PWA installable iOS & Android
                </li>
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  Icône sur écran d'accueil
                </li>
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  Vente en ligne intégrée
                </li>
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  Carte de fidélité
                </li>
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  Espace client
                </li>
                <li className="not-included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                  Notifications push
                </li>
              </ul>
              <div className="lp-offer-actions">
                <Link to="/abonnement-site-pwa#pricing" className="lp-offer-btn-primary lp-offer-btn-purple">
                  Commander
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                </Link>
                <Link to="/abonnement-site-pwa#hero" className="lp-offer-btn-secondary">En savoir plus</Link>
              </div>
            </div>

            {/* Offre App Mobile - Professionnel */}
            <div className="lp-offer-card lp-offer-card-fire">
              <div className="lp-offer-fire-tag">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 23c-3.866 0-7-3.134-7-7 0-2.577 1.409-4.824 3.5-6.019V9c0-2.577 1.409-4.824 3.5-6.019V2c0-.552.448-1 1-1s1 .448 1 1v.981C16.591 4.176 18 6.423 18 9v.981C20.091 11.176 21.5 13.423 21.5 16c0 3.866-3.134 7-7 7h-2.5zm0-2c2.761 0 5-2.239 5-5 0-1.657-1.343-3-3-3-.552 0-1-.448-1-1V9c0-1.657-1.343-3-3-3v3c0 .552-.448 1-1 1-1.657 0-3 1.343-3 3 0 2.761 2.239 5 5 5h1z"/></svg>
                Professionnel
              </div>
              <div className="lp-offer-badge lp-offer-badge-orange">Premium</div>
              <h3>Site + App Mobile</h3>
              <p className="lp-offer-desc">La solution complète tout inclus</p>
              <div className="lp-offer-price">
                <span className="lp-offer-amount">299</span>
                <span className="lp-offer-currency">€</span>
                <span className="lp-offer-period">/mois</span>
              </div>
              <ul className="lp-offer-features">
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  Tout le pack Site + PWA +
                </li>
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  App native iOS (App Store)
                </li>
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  App native Android (Play Store)
                </li>
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  Notifications push illimitées
                </li>
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  Publication sur les stores
                </li>
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  Mises à jour automatiques
                </li>
                <li className="included">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                  Visibilité maximale
                </li>
              </ul>
              <div className="lp-offer-actions">
                <Link to="/abonnement-site-app#pricing" className="lp-offer-btn-primary lp-offer-btn-pink">
                  Commander
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                </Link>
                <Link to="/abonnement-site-app#hero" className="lp-offer-btn-secondary">En savoir plus</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section - Fusionnée */}
      <section className="lp-testimonials" id="testimonials">
        <div className="lp-testimonials-container">
          <div className="lp-testimonials-header">
            <span className="lp-section-tag">Nos clients</span>
            <h2>Ils nous font <span>confiance</span></h2>
            <p>Des professionnels de tous secteurs nous recommandent</p>
          </div>

          {/* Badges métiers */}
          <div className="lp-testimonials-badges">
            <span className="lp-badge-item">Restaurants</span>
            <span className="lp-badge-item">Salons</span>
            <span className="lp-badge-item">Instituts</span>
            <span className="lp-badge-item">Commerces</span>
            <span className="lp-badge-item">Artisans</span>
          </div>

          <div className="lp-testimonials-slider">
            {TESTIMONIALS.map((testimonial, index) => (
              <div
                key={index}
                className={`lp-testimonial-card ${index === activeTestimonial ? 'active' : ''}`}
              >
                {/* Nom et rôle en premier */}
                <div className="lp-testimonial-header">
                  <div className="lp-testimonial-avatar">{testimonial.avatar}</div>
                  <div className="lp-testimonial-info">
                    <strong>{testimonial.author}</strong>
                    <span>{testimonial.role}</span>
                    <span className="lp-testimonial-location">{testimonial.location}</span>
                  </div>
                </div>

                {/* Étoiles */}
                <div className="lp-testimonial-stars">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} viewBox="0 0 24 24" fill="currentColor">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                    </svg>
                  ))}
                </div>

                {/* Avis */}
                <blockquote className="lp-testimonial-text">
                  "{testimonial.text}"
                </blockquote>

                {/* Bouton voir projet */}
                {testimonial.website && (
                  <button
                    className="lp-testimonial-project-btn"
                    onClick={() => openProject(testimonial.website)}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                      <polyline points="15 3 21 3 21 9"/>
                      <line x1="10" y1="14" x2="21" y2="3"/>
                    </svg>
                    <span>Voir leur projet</span>
                  </button>
                )}
              </div>
            ))}
          </div>

          <div className="lp-testimonials-dots">
            {TESTIMONIALS.map((_, index) => (
              <button
                key={index}
                className={`lp-dot ${index === activeTestimonial ? 'active' : ''}`}
                onClick={() => setActiveTestimonial(index)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="lp-faq" id="faq">
        <div className="lp-faq-container">
          <div className="lp-faq-header">
            <span className="lp-section-tag">Besoin d'aide ?</span>
            <h2>Questions <span>fréquentes</span></h2>
            <p>Contactez-nous pour toutes vos questions</p>
          </div>

          <div className="lp-faq-chat">
            <a href="https://wa.me/33743678501?text=Bonjour%2C%20j%27ai%20une%20question%20concernant%20vos%20offres" target="_blank" rel="noopener noreferrer" className="lp-chat-window-link">
            <div className="lp-chat-window">
              <div className="lp-chat-header">
                <div className="lp-chat-header-avatar">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                </div>
                <div className="lp-chat-header-info">
                  <span className="lp-chat-header-name">Support E-Shop</span>
                  <span className="lp-chat-header-status">
                    <span className="lp-chat-status-dot"></span>
                    En ligne
                  </span>
                </div>
              </div>

              <div className="lp-chat-messages">
                <div className="lp-chat-scroll">
                  <div className="lp-chat-message lp-chat-user">
                    <div className="lp-chat-bubble">
                      Quelle offre me conseillez-vous ?
                    </div>
                  </div>
                  <div className="lp-chat-message lp-chat-support">
                    <div className="lp-chat-avatar">M</div>
                    <div className="lp-chat-bubble">
                      Ça dépend de vos besoins ! Le Site Web (89€) est parfait pour démarrer. La PWA (189€) ajoute l'installation sur mobile. L'App (299€) offre les notifications push et la présence sur les stores.
                    </div>
                  </div>

                  <div className="lp-chat-message lp-chat-user">
                    <div className="lp-chat-bubble">
                      C'est quoi la différence entre PWA et App ?
                    </div>
                  </div>
                  <div className="lp-chat-message lp-chat-support">
                    <div className="lp-chat-avatar">M</div>
                    <div className="lp-chat-bubble">
                      La PWA s'installe directement depuis votre site (pas de stores). L'App native est publiée sur l'App Store et Google Play avec notifications push.
                    </div>
                  </div>

                  <div className="lp-chat-message lp-chat-user">
                    <div className="lp-chat-bubble">
                      Je peux changer d'offre plus tard ?
                    </div>
                  </div>
                  <div className="lp-chat-message lp-chat-support">
                    <div className="lp-chat-avatar">M</div>
                    <div className="lp-chat-bubble">
                      Oui, vous pouvez upgrader à tout moment ! On s'occupe de la migration sans frais supplémentaires.
                    </div>
                  </div>
                </div>
              </div>

              <div className="lp-chat-input">
                <span className="lp-chat-input-text">Cliquez pour discuter sur WhatsApp</span>
                <span className="lp-chat-whatsapp-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                </span>
              </div>
            </div>
            </a>

            <div className="lp-faq-side">
              <div className="lp-faq-side-card">
                <div className="lp-faq-side-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72"/>
                  </svg>
                </div>
                <h4>Appelez-nous</h4>
                <p>Notre équipe est disponible pour répondre à toutes vos questions</p>
                <a href="tel:+33743678501" className="lp-faq-side-link">07 43 67 85 01</a>
              </div>

              <div className="lp-faq-side-card">
                <div className="lp-faq-side-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12 6 12 12 16 14"/>
                  </svg>
                </div>
                <h4>Réponse rapide</h4>
                <p>Nous répondons en moyenne en moins de 2 heures</p>
                <span className="lp-faq-side-badge">Support réactif</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Premium */}
      <footer className="lp-footer-premium">
        <div className="lp-footer-gradient-line"></div>
        <div className="lp-footer-premium-container">
          <div className="lp-footer-premium-top">
            <div className="lp-footer-premium-brand">
              <div className="lp-footer-logo">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="lp-footer-logo-icon">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                </svg>
                <span>E-Shops PRO</span>
              </div>
              <p>Votre partenaire digital pour réussir en ligne. Création de sites web, applications mobiles et PWA sur mesure.</p>
            </div>

            <div className="lp-footer-offers">
              <h4>Nos offres</h4>
              <div className="lp-footer-offers-links">
                <Link to="/abonnement-site" className="lp-footer-offer-link">
                  Site Web <span className="lp-footer-price">89€</span>/mois
                </Link>
                <Link to="/abonnement-site-pwa" className="lp-footer-offer-link">
                  Site + PWA <span className="lp-footer-price">189€</span>/mois
                </Link>
                <Link to="/abonnement-site-app" className="lp-footer-offer-link">
                  Site + App <span className="lp-footer-price">299€</span>/mois
                </Link>
              </div>
            </div>

            <div className="lp-footer-premium-column">
              <h4>Contact</h4>
              <a href="tel:+33743678501">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                07 43 67 85 01
              </a>
              <a href="mailto:contact@e-shops-pro.fr">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                contact@e-shops-pro.fr
              </a>
              <a href="https://wa.me/33743678501" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                WhatsApp
              </a>
            </div>
          </div>

          <div className="lp-footer-premium-bottom">
            <p>© {new Date().getFullYear()} E-Shops PRO. Tous droits réservés.</p>
            <p className="lp-footer-legal">
              E-SHOPS PRO SAS · SIRET 881 252 795 00011 · TVA FR20 881 252 795 · 12 rue de la Roquette, 75011 Paris
            </p>
          </div>
        </div>
      </footer>

      {/* Popup Call CTA */}
      {showCallPopup && (
        <div className="lp-call-popup">
          <div className="lp-call-popup-header">
            <h5 className="lp-call-popup-title">Choisissez votre offre</h5>
            <button className="lp-call-popup-close" onClick={() => setShowCallPopup(false)}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>

          <div className="lp-call-popup-content">
            {/* Mockup Site Web Animé */}
            <div className="lp-popup-mockup">
              <div className="lp-popup-browser">
                <div className="lp-popup-browser-bar">
                  <div className="lp-popup-dots">
                    <span></span><span></span><span></span>
                  </div>
                  <div className="lp-popup-url">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    </svg>
                    <span>votre-site.fr</span>
                  </div>
                </div>
                <div className="lp-popup-screen">
                  <div className="lp-popup-nav">
                    <div className="lp-popup-logo"></div>
                    <div className="lp-popup-menu">
                      <span></span><span></span><span></span>
                    </div>
                  </div>
                  <div className="lp-popup-hero">
                    <div className="lp-popup-hero-text">
                      <div className="lp-popup-title"></div>
                      <div className="lp-popup-subtitle"></div>
                      <div className="lp-popup-btn"></div>
                    </div>
                    <div className="lp-popup-hero-img"></div>
                  </div>
                  <div className="lp-popup-cards">
                    <div className="lp-popup-card">
                      <div className="lp-popup-card-icon"></div>
                      <div className="lp-popup-card-title"></div>
                      <div className="lp-popup-card-text"></div>
                    </div>
                    <div className="lp-popup-card">
                      <div className="lp-popup-card-icon"></div>
                      <div className="lp-popup-card-title"></div>
                      <div className="lp-popup-card-text"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="lp-call-popup-cta">
              <span className="lp-call-popup-question">Pas convaincu ?</span>
              <h4>Essayez notre service client</h4>
              <p>Appelez-nous maintenant et constatez par vous-même la différence</p>
              <a href="tel:+33743678501" className="lp-call-popup-btn">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                <span>07 43 67 85 01</span>
              </a>
            </div>
          </div>
        </div>
      )}

      {/* Modal Projet Client */}
      {showProjectModal && (
        <div className="lp-project-modal">
          <div className="lp-project-modal-header">
            <span>Projet réalisé</span>
            <button className="lp-project-modal-close" onClick={() => setShowProjectModal(false)}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M19 12H5M12 19l-7-7 7-7"/>
              </svg>
              <span>Retour à l'offre</span>
            </button>
          </div>
          <iframe
            src={projectUrl}
            title="Projet client"
            className="lp-project-modal-iframe"
          />
        </div>
      )}
    </div>
  );
}

export default Offres;
